import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/freelancenl.webp';
import screenshot_target from '../../../images/letterfunnel/michielvanoudheusden.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Michiel van Oudheusden"
      firstname="Michiel"
      companyname="Freelance.nl"
      competition="Jellow en Hoofdkraan.nl"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/michielvanoudheusden.js